exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".InfoBox{max-width:820px;padding:0 10px;margin:50px auto 40px}.InfoBox h1,.InfoBox h2{text-align:center;margin:10px 0;font-size:32px}.InfoBox p.Overflow-expandableText{white-space:pre-wrap;font-size:16px;line-height:1.6;color:#666}.InfoBox p.Overflow-expandLink{font-size:16px}.InfoBox .Overflow-expandableText--expanded{max-height:2500px}", ""]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"includePaths":["/var/www/web/app"]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/var/www/web/app/sass"]}!./app/src/modules/info_box/info_box.css
// module id = 569
// module chunks = 24